import { render, staticRenderFns } from "./Award.vue?vue&type=template&id=4350a27a&scoped=true"
import script from "./Award.vue?vue&type=script&lang=js"
export * from "./Award.vue?vue&type=script&lang=js"
import style0 from "./Award.vue?vue&type=style&index=0&id=4350a27a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4350a27a",
  null
  
)

export default component.exports